export const apiUrl = "https://dev10.sbagh.com/api/"